import React, { useEffect, useState } from 'react';
import { FlaskConical } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useI18n } from '@/i18n/LanguageContext';
import { isTrainingAccount } from '@/lib/trainingAccount';

/**
 * Persistent label for TEST/TRAINING accounts so a tester (or anyone looking
 * over their shoulder) can never confuse practice data with real customers.
 */
const TrainingBanner: React.FC = () => {
  const { user, profile } = useAuth();
  const { lang } = useI18n();
  const [on, setOn] = useState(false);

  useEffect(() => {
    let alive = true;
    const id = user?.id || profile?.id;
    if (!id) { setOn(false); return; }
    isTrainingAccount(id).then((v) => alive && setOn(v)).catch(() => undefined);
    return () => { alive = false; };
  }, [user?.id, profile?.id]);

  if (!on) return null;
  const es = lang === 'es';
  const role = profile?.user_type === 'gc' ? (es ? 'Contratista general' : 'General Contractor')
    : profile?.user_type === 'subcontractor' ? (es ? 'Subcontratista' : 'Subcontractor')
    : (es ? 'Propietario' : 'Homeowner');

  return (
    <div role="status" className="border-b border-violet-300 bg-violet-600 px-4 py-2 text-center text-xs font-semibold text-white sm:text-sm">
      <span className="inline-flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
        <FlaskConical className="h-4 w-4 shrink-0" />
        <span className="rounded bg-white/20 px-1.5 py-0.5 font-extrabold uppercase tracking-wide">
          {es ? 'Cuenta de PRUEBA / CAPACITACIÓN' : 'TEST / TRAINING ACCOUNT'}
        </span>
        <span>{role}</span>
        <span className="hidden sm:inline">·</span>
        <span>
          {es
            ? 'Datos de práctica. Solo puede desbloquear proyectos [TRAINING] con créditos de demostración. No pague con tarjeta real.'
            : 'Practice data only. You can unlock [TRAINING] projects with demo credits. Never pay with a real card.'}
        </span>
      </span>
    </div>
  );
};

export default TrainingBanner;
